
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import {get,post} from './api'
export default {
components: {
Flexbox,
FlexboxItem,
XInput,
XButton,
Group,
Cell,
XImg
},
mounted() {

},
methods: {











goPage(index){
switch(index){
case 1:
this.$router.push({ path: '/SearchPage' });
break;
case 2:
this.$router.push({ path: '/LoginPage?tag=B' });
break;
case 3:
this.$router.push({ path: '/LoginPage?tag=M' });
break;
}
}
},
data () {
return {

}
}
}



// WEBPACK FOOTER //
// ./src/components/StartPage.vue